import { Content } from 'shared/components/Content';
import { ModalContainer } from '../ModalContainer';
import { HeaderContainer } from '../HeaderContainer';
import { DoorsContainer } from '../DoorsContainer';
import { PredictionContainer } from '../PredictionContainer';

export const ContentContainer: React.FC = () => {
  return (
    <Content
      modal={<ModalContainer />}
      header={<HeaderContainer />}
      doors={<DoorsContainer />}
      prediction={<PredictionContainer />}
    />
  );
};
